import { SortableHeader } from '@/components/search/SortableHeader'
import React, { useRef, useState } from 'react'
import { Services } from '@/services/services';
import { CurrentSession } from '@/services/repository/session';
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout';
import { PageQuery, PageResponse, SearchTable, SearchTableParams, SearchTableRef } from '@/components/search/SearchTable';
import { useModal } from '@/components/modal/Modal';
import { formatDate } from '@/common/time';
import { isDesktopScreen, useResponsiveChange } from '@/common/device';
import { BackButton } from '@/components/layout/NavBar';
import { MainPageLayout } from '@/components/layout/MainLayout';
import { useTranslations } from '@/hooks/useTranslations';
import { useParams } from 'react-router-dom';
import { MapPointComponent, MapPointRow } from '@/components/Map/MapPoint';
import { useAppContext } from '@/context/app';
import { Spinner } from '@/components/spinner';

export interface MachineCanError {
  id: string
  createdAt: string
  errors: string[]
}

export const CanErrorSearchPage = () => {
  const { services, session, translates } = useAppContext()
  const searchTableRef = useRef<SearchTableRef>(null)
  const machineId = useParams().mid
  const [error, setError] = useState<boolean>(false)
  // const { openModal } = useModal()

  useResponsiveChange()

  if (!session || !translates) {
    return <Spinner />
  }

  const tableParams: SearchTableParams<MachineCanError> = {
    fetch: (q: PageQuery): Promise<PageResponse<MachineCanError>> => {
      const searchParams = new URLSearchParams({
        pageNumber: q.pageNumber.toString() || '',
        pageSize: q.pageSize.toString() || '',
        search: q.search || '',
        sortBy: q.sortBy || '',
        sortDirection: q.sortDirection || '',
      });
      return services.session.fetchWithToken(`/api/communal/machines/byid/${machineId}/can/errors?${searchParams.toString()}`).then((r) => {
        if (r.status === 200) {
          return r.json()
        } else {
          setError(true)
          return Promise.reject()
        }
      })
    },
    pageQuery: {
      pageNumber: 1,
      pageSize: 30,
      search: ""
    },
    defaultSortBy: 'createdAt',
    header: (query, onSort) => <>
      <SortableHeader field='createdAt' query={query} onSort={onSort}>{session.translates.for('elements.table.can_errors.created_at')}</SortableHeader>
      <SortableHeader field='errors' query={query} onSort={onSort}>{session.translates.for('elements.table.can_errors.errors')}</SortableHeader>
      <div className='hcol'></div>
    </>,
    row: (row) => <>
      <div className='col'>{formatDate(new Date(row.createdAt))}</div>
      <div className='col'>{row.errors?.map((err) => <span onClick={() => {
        alert('open AI wizard')
      }}>
        {err}
      </span>)}</div>
    </>,
    translates: session.translates
  }

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return (
    <MainPageLayout pageName='can-error-search' services={services} session={session} translates={translates}
      navbarLeft={<BackButton services={services} translates={translates} />}>
      {error ? <div className='critic-error-box'>{translates.for('errors.general_error')}</div> : <SearchTable ref={searchTableRef} {...tableParams} />}
    </MainPageLayout>
  )
}